/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Still_Tame_Goat_GrabInputs */

const en_still_tame_goat_grab = /** @type {(inputs: Still_Tame_Goat_GrabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing sentiment, translating comments, and extracting keywords.`)
};

const de_still_tame_goat_grab = /** @type {(inputs: Still_Tame_Goat_GrabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stimmung wird analysiert, Kommentare übersetzt und Schlüsselwörter extrahiert.`)
};

/**
* | output |
* | --- |
* | "Analyzing sentiment, translating comments, and extracting keywords." |
*
* @param {Still_Tame_Goat_GrabInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const still_tame_goat_grab = /** @type {((inputs?: Still_Tame_Goat_GrabInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Still_Tame_Goat_GrabInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_still_tame_goat_grab(inputs)
	return de_still_tame_goat_grab(inputs)
});